import { render, staticRenderFns } from "./RequestPersonSignatureForFilledDocumentModal.vue?vue&type=template&id=12a164e2&scoped=true&"
import script from "./RequestPersonSignatureForFilledDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./RequestPersonSignatureForFilledDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a164e2",
  null
  
)

export default component.exports